import React, { Component } from 'react';

const SortArrow = ({ sortFunction, sortAscending, sortKey }) => {
    //let arrowType = sortAscending == true ? "arrow-up" : "arrow-down";
    let arrowType = sortAscending == true ? "triangle-bottom" : "triangle-top";
    const iconClass = "glyphicon glyphicon-" + arrowType;
    return (<span className={iconClass} onClick={() => sortFunction(sortKey, sortAscending)}></span>);
}

class TableHeader extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        let sortAscending = this.props.sortAscending;
        let sortFunction = this.props.sortFunction;
        return (
            <thead>
                <tr>
                    <th>
                        <label>ADMINISTRADORA</label>
                        <SortArrow sortFunction={sortFunction} sortAscending={sortAscending.administradora} sortKey="administradora" />
                    </th>
                    <th>
                        <label>APLICA A</label>
                        <SortArrow sortFunction={sortFunction} sortAscending={sortAscending.ambito} sortKey="ambito" />
                    </th>
                    <th>
                        <label>LÍMITE ANTERIOR</label>
                    </th>
                    <th>
                        <label>LÍMITE NUEVO</label>
                    </th>
                </tr>
            </thead>
        );
    }
}

export default TableHeader;